import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg<{ gray?: boolean }>`
  fill: ${({ gray }): string => (gray ? '#B0B0B0' : '#423f9a')};
  height: 24px;
  width: 24px;
`

export const CardMembershipIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 10.7885V12.6923C2 12.7692 2.03208 12.8398 2.09625 12.9038C2.16025 12.9679 2.23075 13 2.30775 13H17.6923C17.7693 13 17.8398 12.9679 17.9038 12.9038C17.9679 12.8398 18 12.7692 18 12.6923V10.7885H2ZM2.30775 0.5H17.6923C18.1909 0.5 18.6169 0.676583 18.9703 1.02975C19.3234 1.38308 19.5 1.80908 19.5 2.30775V12.6923C19.5 13.1909 19.3234 13.6169 18.9703 13.9703C18.6169 14.3234 18.1909 14.5 17.6923 14.5H13.4615V19.1345L10 17.4038L6.5385 19.1345V14.5H2.30775C1.80908 14.5 1.38308 14.3234 1.02975 13.9703C0.676583 13.6169 0.5 13.1909 0.5 12.6923V2.30775C0.5 1.80908 0.676583 1.38308 1.02975 1.02975C1.38308 0.676583 1.80908 0.5 2.30775 0.5ZM2 8.2115H18V2.30775C18 2.23075 17.9679 2.16025 17.9038 2.09625C17.8398 2.03208 17.7693 2 17.6923 2H2.30775C2.23075 2 2.16025 2.03208 2.09625 2.09625C2.03208 2.16025 2 2.23075 2 2.30775V8.2115ZM2 12.6923V2H2.30775C2.23075 2 2.16025 2.03208 2.09625 2.09625C2.03208 2.16025 2 2.23075 2 2.30775V12.6923C2 12.7692 2.03208 12.8398 2.09625 12.9038C2.16025 12.9679 2.23075 13 2.30775 13H2V12.6923Z" />
    </Svg>
  )
}
